// Auto-generated normalizer for table: Empleados_Turnos
export function empleadosTurnosNormalize(row) {
  return {
    idEmpleadoTurno: row.idEmpleadoTurno ?? row.IdEmpleadoTurno ?? row['IdEmpleadoTurno'] ?? 0,
    idEmpleado: row.idEmpleado ?? row.IdEmpleado ?? row['IdEmpleado'] ?? 0,
    idTurno: row.idTurno ?? row.IdTurno ?? row['IdTurno'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    fechaAsignacion: row.fechaAsignacion ?? row.FechaAsignacion ?? row['FechaAsignacion'] ?? null,
  };
}
